import React from 'react';
import { useTranslation } from 'react-utilities';
import { NAPageItemConfigType } from '../ConfigTypes';
import getRobloxUrl from '../../utils/getRobloxUrl';
import determineProceedAction from '../../utils/determineProceedAction';
import { ProceedAction } from '../../utils/types';
import makeTranslateWithLink from '../../utils/makeTranslateWithLink';
import { EventTypes } from '../../services/eventConstants';

/**
 * Content and page link for the reactivation notice. Shown based on proceedAction being Reactivate
 */
const ReactivateNoticePageItem = (): JSX.Element => {
  const { translate } = useTranslation();
  const translateWithLink = makeTranslateWithLink(translate);
  const termsOfUseUrl = getRobloxUrl('/info/terms');

  return (
    <div data-testid='reactivate-notice'>
      {translateWithLink(
        'Description.ReactivateAccount',
        termsOfUseUrl,
        undefined,
        EventTypes.TermsOfUseClicked
      )}
    </div>
  );
};

const ReactivateNoticePageItemConfig: NAPageItemConfigType = {
  getIsVisible: punishmentData => {
    return determineProceedAction(punishmentData) === ProceedAction.Reactivate;
  },
  renderComponent: ReactivateNoticePageItem,
  configName: 'reactivate-notice'
};

export default ReactivateNoticePageItemConfig;
